var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalDialog',{ref:"dialog",attrs:{"title":_vm.title,"icon":_vm.icon,"showFooter":false}},[_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.message))]),_c('div',{staticStyle:{"width":"100%"}},[_c('Spinner')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }